import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Critical resource hints - minimize to essentials
if (typeof window !== 'undefined') {
  // Preconnect to CDN with high priority
  const preconnectCDN = document.createElement('link');
  preconnectCDN.rel = 'preconnect';
  preconnectCDN.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(preconnectCDN);
  // Preload LCP image with fetchpriority
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = 'https://cdn.magicpatterns.com/uploads/1gwhDJbWYAzPqP47WvppdA/ChatGPT_Image_9_ago_2026__14_24_27-removebg-preview.png';
  preload.type = 'image/png';
  preload.fetchPriority = 'high';
  document.head.appendChild(preload);
}
render(<App data-id="element-241" data-mp="2tzwi3ampj61l" />, document.getElementById('root'));